export const APP_NAME: string = "bidm";
